<template>
  <div class="dataapi-toolbar">
    <el-button
      @click="$emit('select')"
      :disabled="mergadConfig.isSelectDisabled"
      :class="[!mergadConfig.isSelectDisabled ? 'toolbarActive' : '']"
    >
      <img
        v-if="mergadConfig.isSelectDisabled"
        src="@/assets/images/dataServices/dataapi-img/Select.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Select-active.svg"
        alt=""
      />
      Select</el-button
    >
    <el-button
      @click="$emit('download')"
      :disabled="mergadConfig.isDownloadDisabled"
      :class="[!mergadConfig.isDownloadDisabled ? 'toolbarActive' : '']"
    >
      <img
        v-if="mergadConfig.isDownloadDisabled"
        src="@/assets/images/dataServices/dataapi-img/Download.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Download-active.svg"
        alt=""
      />
      Download</el-button
    >
    <el-button
      @click="$emit('createComb')"
      :disabled="mergadConfig.isCreateCombDisabled"
      :class="[!mergadConfig.isCreateCombDisabled ? 'toolbarActive' : '']"
      v-if="mergadConfig.isCreateCombShow"
    >
      <img
        v-if="mergadConfig.isCreateCombDisabled"
        src="@/assets/images/dataServices/dataapi-img/Createacomb.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Createacomb-active.svg"
        alt=""
      />
      Create a comb</el-button
    >
    <el-button
      @click="$emit('reselect')"
      :disabled="mergadConfig.isReselectDisabled"
      :class="[!mergadConfig.isReselectDisabled ? 'toolbarActive' : '']"
    >
      <img
        v-if="mergadConfig.isReselectDisabled"
        src="@/assets/images/dataServices/dataapi-img/Regular.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Regular-active.svg"
        alt=""
      />
      Reselect</el-button
    >
    <el-button
      @click="$emit('createComponent')"
      :disabled="mergadConfig.isCreateComponentDisabled"
      :class="[!mergadConfig.isCreateComponentDisabled ? 'toolbarActive' : '']"
      v-if="mergadConfig.isCreateComponentShow"
    >
      <img
        v-if="mergadConfig.isCreateComponentDisabled"
        src="@/assets/images/dataServices/dataapi-img/Createacomb.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Createacomb-active.svg"
        alt=""
      />
      Create new component</el-button
    >
    <el-button
      @click="$emit('export')"
      :disabled="mergadConfig.isExportDisabled"
      :class="[!mergadConfig.isExportDisabled ? 'toolbarActive' : '']"
      v-if="mergadConfig.isExportShow"
    >
      <img
        v-if="mergadConfig.isExportDisabled"
        src="@/assets/images/dataServices/dataapi-img/Export.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Export-active.svg"
        alt=""
      />
      Export</el-button
    >
    <el-button
      @click="$emit('fitlers')"
      :disabled="mergadConfig.isFitlersDisabled"
      :class="[!mergadConfig.isFitlersDisabled ? 'toolbarActive' : '']"
      v-show="mergadConfig.isFitlersShow"
    >
      <img
        v-if="mergadConfig.isFitlersDisabled"
        src="@/assets/images/dataServices/dataapi-img/Fitlers.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Fitlers-active.svg"
        alt=""
      />
      Fitlers</el-button
    >
    <el-button
      @click="$emit('cart')"
      :disabled="mergadConfig.isCartDisabled"
      :class="[!mergadConfig.isCartDisabled ? 'toolbarActive' : '']"
      v-show="mergadConfig.isCartShow"
    >
      <img
        v-if="mergadConfig.isCartDisabled"
        src="@/assets/images/dataServices/dataapi-img/Carts.svg"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/dataServices/dataapi-img/Carts-active.svg"
        alt=""
      />
      Cart <span v-if="cartsTotalCount"> ({{ cartsTotalCount }})</span></el-button
    >
  </div>
</template>

<script>
export default {
  props: ["ToolBarData",'cartsTotalCount'],
  data() {
    return {};
  },
  components: {},
  computed: {
    mergadConfig() {
      return {
        isCartDisabled: true,
        isSelectDisabled: true,
        isDownloadDisabled: true,
        isCreateCombDisabled: true,
        isReselectDisabled: true,
        isCreateComponentDisabled: true,
        isExportDisabled: true,
        isFitlersDisabled: true,

        isCreateCombShow: false,
        isCreateComponentShow: false,
        isExportShow: false,
        isFitlersShow: false,
        isCartShow:false,
        ...this.ToolBarData,
      };
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
/* 工具栏 开始 */
.dataapi-toolbar {
  height: 56px;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0.5rem 60px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-top: 1px solid #eee;
  top: 88px;
  z-index: 90;
  align-items: center;
  position: fixed;
  width: 100%;
}
.dataapi-toolbar .el-button {
  background-color: #fff !important;
  padding: 0 !important;
  color: #8497ab !important;
  font-size: 16px;
}
.dataapi-toolbar .el-button /deep/ span{
  display: flex;
  align-items: center;
  gap: 5px;
}
/* .dataapi-toolbar .el-button img { */
  /* vertical-align: middle; */
  /* margin-right: 5px; */
/* } */
.dataapi-toolbar .el-button.toolbarActive {
  color: #1a2332 !important;
}
/* 工具栏 结束 */
@media (max-width: 1920px) {
  .dataapi-toolbar{
    top:58px;
    height: 40px;
  }
  .dataapi-toolbar .el-button {
    font-size:14px;
  }
}
@media (max-width: 1440px) {
  .dataapi-toolbar {
    top: 58px;
    height: 40px;
    padding: 0.5rem 34px;
  }
  .dataapi-toolbar .el-button {
    font-size: 12px;
  }
}
</style>
